<template>
  <div class="container">
    <div class="diy-service">
      <h2>灵活多变的定制化服务</h2>
      <el-row class="count-list">
        <el-col class="flex-center" v-for="(item, index) in diyList" :key="index" :xs="12" :sm="8" :md="8" :lg="4" :xl="4">
          <div class="diy-list">
            <img :src="item.image" alt="">
            <p>{{item.title}}</p>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="download-now">
      <div class="download-header">
        <h2>点击体验网页版，实时跟踪任务状态</h2>
      </div>
      <div class="download-btn flex-center" @mouseenter="buttonEnter">
        <a target="_brank" href="https://v.renderg.com/#/login" class="flex-align-center">
          <!-- <div class="button-img">
            <img src="../../assets/image/render/windows.png" alt="">
          </div> -->
          <p>立即跳转</p>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../assets/js/api'
export default {
  data() {
    return {
      diyList: [
        {
          image: require('../../assets/image/render/diy1.png'),
          title: 'API 和 SDK 支持'
        },
        {
          image: require('../../assets/image/render/diy2.png'),
          title: '公有云部署'
        },
        {
          image: require('../../assets/image/render/diy3.png'),
          title: 'TD 技术支持'
        },
        {
          image: require('../../assets/image/render/diy4.png'),
          title: '专线覆盖'
        },
        {
          image: require('../../assets/image/render/diy5.png'),
          title: '智能报表'
        },
        {
          image: require('../../assets/image/render/diy6.png'),
          title: '自定义渲染环境'
        },
      ],
      download_client_url: ''
    }
  },
  created() {
    this.getType()
  },
  methods: {
    getType () {
      api.getVersion(10808)
        .then((res) => {
          this.download_client_url = res.download_url_cdn
        })
    },
    buttonEnter () {
      this.getType()
    }
  },
}
</script>